import { AgTechHttpRequest } from "@agtech/core/data/actions/AgTechHttpRequests";
import { useAgTechApiDownloadRequest } from "@agtech/core/data/http/AgTechApiGetRequests";

export const useReportDataGetAfterSaleReportRequest = (): AgTechHttpRequest<number, any> => {
    let afterSaleReportRequest = useAgTechApiDownloadRequest();

    return {
        execute: async props => await afterSaleReportRequest.download({
            path: 'Sales/GetAfterSaleReportDocument/' + props.data,
            fileNameWithExtension: `AfterSaleReport_${new Date().toDateString()}.pdf`
        })
    }
}

export const useReportDataGetOutstandingCreditsReportRequest = (): AgTechHttpRequest<any, any> => {
    let outstandingCreditsRequest = useAgTechApiDownloadRequest();

    return {
        execute: async () =>  await outstandingCreditsRequest.download({
            path: 'ContactCredit/GetOutstandingContactCreditsReport',
            fileNameWithExtension: `OutstandingCredits_${new Date().toDateString()}.pdf`
        })
    }
}

export const useReportDataGetLotOrderReportRequest = (): AgTechHttpRequest<number, any> => {
    let lotOrderRequest = useAgTechApiDownloadRequest();

    return {
        execute: async props =>  await lotOrderRequest.download({
            path: 'Lot/GetSaleOrderDocument/' + props.data,
            fileNameWithExtension: `LotSaleOrder_${new Date().toDateString()}.pdf`
        })
    }
}

export const useReportDataGetLotsByPurchaserReportRequest = (): AgTechHttpRequest<number, any> => {
    let lotsByPurchaserRequest = useAgTechApiDownloadRequest();

    return {
        execute: async props => await lotsByPurchaserRequest.download({
            path: 'Sales/GetLotsByPurchasersReport/' + props.data,
            fileNameWithExtension: `LotsByPurchaser_${new Date().toDateString()}.pdf`
        })
    }
}

export const useReportDataGetLotsPurchasedInOrderReportRequest = (): AgTechHttpRequest<number, any> => {
    let lotsByPurchaserRequest = useAgTechApiDownloadRequest();

    return {
        execute: async props => await lotsByPurchaserRequest.download({
            path: 'Sales/GetLotsPurchasedInOrderReport/' + props.data,
            fileNameWithExtension: `LotsInOrderByPurchaser_${new Date().toDateString()}.pdf`
        })
    }
}

export const useReportDateGetUnpaidInvoicesRequest = (): AgTechHttpRequest<number, any> => {
    let lotsByPurchaserRequest = useAgTechApiDownloadRequest();

    return {
        execute: async props => await lotsByPurchaserRequest.download({
            path: 'Invoice/GetUnpaidInvoiceReport/' + props.data,
            fileNameWithExtension: `UnpaidInvoicesReport_${new Date().toDateString()}.pdf`
        })
    }
}